import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/sections/Header";
import { Hero } from "@/sections/Hero";
import { Manifesto } from "@/sections/Manifesto";
import { Gallery } from "@/sections/Gallery";
import { FloorPlan } from "@/sections/FloorPlan";
import { Amenities } from "@/sections/Amenities";
import { Reviews } from "@/sections/Reviews";
import { Location } from "@/sections/Location";
import { InstagramFeed } from "@/sections/Instagram";
import { Contact } from "@/sections/Contact";
import { Footer } from "@/sections/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { SurveyOverlay } from "@/components/SurveyOverlay";
import { CorsicaMap } from "@/components/CorsicaMap";
import Admin from "@/pages/Admin";

function Home() {
  useLenis();
  return (
    <div className="App grain bg-sand-bg" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <Gallery />
        <FloorPlan />
        <Amenities />
        <Reviews />
        <Location />
        <CorsicaMap />
        <InstagramFeed />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <SurveyOverlay />
      <Toaster position="bottom-right" />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
